/** @format */

import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PriceCohort from "./price-cohort";
import OrderingPlatform from "./ordering-platform";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Setup = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", mt: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons
          variant="scrollable"
          allowScrollButtonsMobile
        >
          <Tab label="Price Cohort" />
          <Tab label="Ordering Platform" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <PriceCohort />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <OrderingPlatform />
      </TabPanel>
    </Box>
  );
};

export default Setup;
